import { useEffect, useState } from 'react';

import apiService from 'services';

import type { SourceFile, SourceStats } from './sourcesTableUtils';

/**
 * The sources list endpoint only returns id / name / type / created date. The
 * version count, row count and last-updated date live on the versions
 * endpoint, so each source is fetched once and the result is kept here.
 */
const useSourceStats = (sources: SourceFile[]) => {
  const [stats, setStats] = useState<Record<number, SourceStats>>({});

  const idsKey = sources.map((source) => source.id).join(',');

  useEffect(() => {
    let cancelled = false;

    sources.forEach((source) => {
      apiService
        .getVersionData(source.id)
        .then((response: any) => {
          if (cancelled) return;
          const versions: any[] = response?.data?.versions || [];
          const latest = versions[0];
          setStats((previous) => ({
            ...previous,
            [source.id]: {
              versions: versions.length,
              rows: latest?.row_count ?? null,
              lastUpdated: latest?.date_created ?? source.date_created ?? null,
            },
          }));
        })
        .catch(() => {
          if (cancelled) return;
          setStats((previous) => ({
            ...previous,
            [source.id]: {
              versions: 0,
              rows: null,
              lastUpdated: source.date_created ?? null,
            },
          }));
        });
    });

    return () => {
      cancelled = true;
    };
  }, [idsKey]);

  return stats;
};

export default useSourceStats;
